// extracted by mini-css-extract-plugin
export default {"root":"actionBtns_root__rmH-6"};